// Food (/posilki…): Today, Week, Catalogue, Products, Settings, sheets and dialogs.
export default {
    common: {
        add: 'Add',
        adding: 'Adding…',
        save: 'Save',
        saving: 'Saving…',
        delete: 'Delete',
        edit: 'Edit',
        cancel: 'Cancel',
        close: 'Close',
        back: 'Back',
        less: 'Less',
        more: 'More',
        up: 'Up',
        down: 'Down',
        loading: 'Loading…',
        portions: 'Servings',
        fewerServings: 'Fewer servings',
        moreServings: 'More servings',
        servingsN: '{n} serving | {n} servings',
        ingredientsHeading: 'INGREDIENTS',
        aiUnavailable: 'AI is unavailable right now.',
    },
    errors: {
        save: 'Couldn’t save.',
        add: 'Couldn’t add.',
        addProduct: 'Couldn’t add the product.',
        saveMeal: 'Couldn’t save the meal.',
        delete: 'Couldn’t delete.',
        generic: 'Something went wrong.',
    },
    ingredient: 'Ingredient',
    days: {
        today: 'Today',
        tomorrow: 'Tomorrow',
        yesterday: 'Yesterday',
    },
    units: {
        label: {
            szt: 'pcs',
            lyzka: 'tbsp',
            lyzeczka: 'tsp',
            szklanka: 'cup',
            porcja: 'serving',
        },
        amount: {
            lyzka: '{n} tbsp | {n} tbsp',
            lyzeczka: '{n} tsp | {n} tsp',
            szklanka: '{n} cup | {n} cups',
            porcja: '{n} serving | {n} servings',
        },
    },
    nutrients: {
        label: {
            calories: 'Calories',
            protein: 'Protein',
            carbs: 'Carbs',
            fat: 'Fat',
            fiber: 'Fibre',
            sugar: 'Sugar',
            saturated_fat: 'Saturated fat',
            salt: 'Salt',
        },
        short: {
            protein: 'P',
            carbs: 'C',
            fat: 'F',
            fiber: 'fibre',
            sugar: 'sugar',
            saturated_fat: 'saturated',
            salt: 'salt',
        },
        macros: 'P {protein} · C {carbs} · F {fat}',
    },
    goalKinds: {
        target: { label: 'goal', hint: 'aim for around this' },
        min: { label: 'at least', hint: 'less is too little' },
        max: { label: 'at most', hint: 'more is too much' },
    },
    portions: {
        half: '½ serving',
        count: '{n} serving | {n} servings',
        defaultName: 'serving',
    },
    slots: {
        none: 'No meal time',
    },
    source: {
        nutrition: {
            label: 'from the label',
            manual: 'corrected',
            ai: 'AI estimate',
        },
        price: {
            receipt: 'from a receipt',
            basket: 'from shopping',
            label: 'from the label',
            manual: 'corrected',
            ai: 'AI estimate',
        },
    },
    aiMacros: {
        field: {
            protein: 'P',
            carbs: 'C',
            fat: 'F',
            saturated_fat: 'sat.',
            sugar: 'sugars',
            fiber: 'fibre',
            salt: 'salt',
            category: 'category',
        },
        error: {
            notFound: 'This entry no longer exists — refresh the view.',
            rejected: 'The API didn’t accept the macros request.',
            noAnswer: 'The AI didn’t respond. Try again.',
            notConfigured: 'AI isn’t configured on the API side.',
            generic: 'Couldn’t get macro suggestions.',
        },
        dialog: {
            title: 'Fill in macros with AI',
            subjectIngredients: 'Ingredients of “{name}”',
            productIngredients: 'Ingredient products',
            units: 'values per 100 g, salt in mg, price in {currency}/kg',
            loading: 'Asking AI for the ingredients’ macros…',
            retry: 'Try again',
            empty: 'The AI returned no suggestions for this meal.',
            counts: 'PRODUCTS: {total} · TO CHANGE: {changed}',
            unselectAll: 'Deselect all',
            selectAll: 'Select all',
            noChanges: 'no changes',
            hint: 'Changes are saved to catalogue products — the API will recalculate the macros of meals that use them.',
            apply: 'Apply',
            applyN: 'Apply ({n})',
        },
    },
    entry: {
        cookingServings: 'cooking {n} servings',
        fromCooking: 'from cooking',
        fromPhoto: 'from a photo',
        typed: 'typed in',
    },
    today: {
        savedFlash: 'Saved: {name}.',
        openRecipeFailed: 'Couldn’t open the recipe.',
        chatSaved: 'New meal: {name} — add it to a meal time.',
        eatenSubtitle: '{kcal} eaten',
        action: 'What I ate',
        prevDay: 'Previous day',
        nextDay: 'Next day',
        legacy: {
            title: 'Move your meals over',
            text: 'In the old Food you have {n} meals and semi-products — I’ll move them here along with your sets and entries from the last 90 days.',
            action: 'Move over',
        },
        balance: 'DAY BALANCE',
        fillDayAi: 'Fill the day with AI',
        otherSlot: 'Other',
        addTo: 'Add to: {name}',
        undoEaten: 'Undo: {name}',
        markEaten: 'Eaten: {name}',
        noSlots: 'You don’t have any meal times — add them in {settings}.',
        noSlotsLink: 'settings',
        offPlan: 'I ate something off-plan',
    },
    counts: {
        meals: '{n} meal | {n} meals',
        semiProducts: '{n} semi-product | {n} semi-products',
        sets: '{n} set | {n} sets',
        entries: '{n} entry | {n} entries',
    },
    week: {
        title: 'Week',
        setApplied: '“{name}” added to {day}.',
        sentToList: 'On the “{list}” list: {n} item. | On the “{list}” list: {n} items.',
        markedBought: 'Marked as bought.',
        chatSaved: 'New meal: {name} — pick it in a meal time.',
        cost: 'approx. {cost}',
        prevWeek: 'Previous week',
        thisWeek: 'This week',
        nextWeek: 'Next week',
        toBasket: 'To Groceries',
        showPast: 'Show past days ({n})',
        moreFor: 'More: {date}',
        insertSet: 'Insert a set',
        logEaten: 'Log what you ate',
        cookingShort: 'cooking {n}',
        eaten: 'eaten',
        addSlot: 'Add: {name}, {date}',
    },
    catalogue: {
        favorites: 'Favourites',
        favorite: 'Add “{name}” to favourites',
        unfavorite: 'Remove “{name}” from favourites',
        favoriteFailed: 'Could not save the favourite.',
        title: 'Meals',
        mealsCount: '{n} meal | {n} meals',
        setsCount: '{n} set | {n} sets',
        newMeal: 'New meal',
        newSet: 'New set',
        sort: {
            name: 'Name',
            recent: 'Recently eaten',
            kcal: 'Lightest',
            protein: 'Most protein',
        },
        changedFlash: 'Changed: {name}.',
        newMealFlash: 'New meal: {name}.',
        setSaved: 'Set “{name}” saved.',
        setDeleted: 'Set deleted.',
        tabMeals: 'Meals',
        tabSets: 'Day sets',
        searchPlaceholder: 'Search meals…',
        search: 'Search meals',
        order: 'Order',
        all: 'All',
        pricePerServing: 'approx. {price} / serving',
        servingsFor: 'makes {n} servings',
        choices: 'choice of: {list}',
        noIngredients: 'no ingredients',
        emptyFiltered: 'Nothing matches here',
        empty: 'You don’t have any meals yet',
        emptyFilteredHint: 'Change the filter or search phrase.',
        emptyHint: 'Add your first one, or move meals over from the old Food in settings.',
        setsIntro: 'Ready-made days you drop into the Week in one go — no planning from scratch.',
        planSet: 'Build a set for your goal',
        setsEmpty: 'You don’t have any sets yet — “New set” will build your first day.',
        withAi: 'With AI',
        withAiHint: 'Describe what you want, paste a recipe or a link, or take a photo of a dish or a cookbook page.',
        manual: 'Manually',
        manualHint: 'You enter the ingredients, servings and recipe yourself.',
    },
    products: {
        title: 'Products',
        count: '{n} product | {n} products',
        synced: {
            both: 'Filled in with estimates: {estimated}, prices from receipts: {prices}.',
            estimated: 'Filled in with estimates: {estimated}.',
            prices: 'Prices from receipts: {prices}.',
        },
        filter: {
            all: 'All',
            estimate: 'AI estimates',
            missing: 'No data',
        },
        scannedNew: 'New product: {product} ({variant}).',
        scannedExisting: '{variant} → {product}.',
        badge: {
            missing: 'no data',
            label: 'label',
        },
        scan: 'Scan packaging',
        newPlaceholder: 'New product, e.g. bulgur wheat — AI will fill in the rest',
        newName: 'New product name',
        searchPlaceholder: 'Search products or brands…',
        search: 'Search products',
        per100: 'P {protein} · C {carbs} · F {fat} / 100 g',
        packages: '{n} package | {n} packages',
        emptyFiltered: 'Nothing matches.',
        empty: 'Scan your first package or add a product by name.',
        deleted: 'Deleted: {name}.',
    },
    settings: {
        title: 'Settings',
        subtitle: 'Food',
        errors: {
            save: 'Couldn’t save the meal time.',
            add: 'Couldn’t add the meal time.',
            remove: 'Couldn’t delete the meal time.',
            move: 'Couldn’t move the data.',
        },
        slots: {
            title: 'Meal times',
            description: 'Your planned day is made of these. The time is optional — it sets the order on the Planner timeline and the default meal time for a quick entry.',
            name: 'Meal time name {n}',
            time: 'Time: {name}',
            up: '{name} up',
            down: '{name} down',
            remove: 'Delete: {name}',
            newPlaceholder: 'New meal time, e.g. Pre-workout',
            newName: 'New meal time name',
            newTime: 'Time for the new meal time',
            removeTitle: 'Delete this meal time?',
            removeMessage: 'Entries from this meal time will stay in the day, without a meal time.',
        },
        goals: {
            title: 'Goals and preferences',
            description: 'One place for the whole app: daily goals (kcal, macros, fibre, sugar, salt) and what you don’t eat — used by the day balance, the Planner and AI suggestions.',
            open: 'Open goals and preferences',
        },
        legacy: {
            title: 'Data from the old Food',
            description: 'Meals (semi-products become meals with servings, dish variants become separate meals), day sets and entries from the last 90 days. The old module stays untouched, and moving again only adds what’s new.',
            moved: 'Moved: {meals}, {sets}, {entries}.',
            nothingNew: 'Everything had already been moved.',
            summary: 'In the old module: {meals}, {semi}, {sets}, {entries}.',
            movedAt: 'Moved {date}.',
            moving: 'Moving…',
            moveNew: 'Move new items',
            moveMine: 'Move my data',
        },
    },
    goals: {
        inPlan: 'in the plan',
        change: 'Change goals',
        set: 'Set goals',
    },
    setPicker: {
        loadFailed: 'Couldn’t load the sets.',
        applyFailed: 'Couldn’t insert the set.',
        title: 'Insert a set · {day}',
        replace: 'Replace the day’s plan',
        replaceHint: '(eaten items stay)',
        empty: 'You don’t have any sets yet. Build your first one in {tab}.',
        emptyTab: 'Meals → Day sets',
    },
    shoppingSheet: {
        loadFailed: 'Couldn’t gather the ingredients.',
        sendFailed: 'Couldn’t add to Groceries.',
        otherCategory: 'Other',
        subtitle: 'Untick what you have at home — the rest goes to your default list.',
        from: 'From',
        to: 'To',
        loading: 'Gathering ingredients…',
        alreadySent: 'Skipping {n} meal sent earlier. | Skipping {n} meals sent earlier.',
        empty: 'Nothing to buy for these days — plan meals in the Week or change the range.',
        mealEmpty: 'This meal has no ingredients from products — nothing to add.',
        mealSubtitle: 'Ingredients of “{name}” — untick what you have at home.',
        servings: 'For how many servings',
        recipeFor: 'recipe for {n} serving | recipe for {n} servings',
        forWhat: 'for: {what}',
        have: 'got it',
        send: 'Add {n} to Groceries',
        haveAll: 'I have everything',
    },
    mealPicker: {
        favorites: 'FAVOURITES',
        meal: 'Meal',
        fromCooking: 'FROM COOKING',
        cooked: 'cooked {day} · {left} left',
        fitsSlot: 'FITS {slot}',
        recent: 'RECENTLY EATEN',
        results: 'RESULTS',
        all: 'ALL',
        perServing: '{kcal} / serving',
        empty: 'You don’t have any meals yet. Add them in the Meals tab or log what you ate.',
        noMatch: 'Nothing matches “{query}”.',
        cookMore: 'I’m cooking extra servings',
        servingsUnit: 'servings',
        cookHint: 'The remaining servings will appear at the top of the picker on the following days as “From cooking” — and only this cooking goes on the shopping list.',
        quick: 'Type what it was',
    },
    entrySheet: {
        photo: 'Meal photo',
        fromCooking: 'Serving from cooking: {day}',
        skipped: 'Planned, but you ate something else.',
        howMuch: 'How much you ate',
        cooking: 'Cooking',
        cookingState: 'servings · {used} planned, {left} left',
        stopCooking: 'Not cooking ahead',
        cookHint: 'Cook extra and spread the servings over the following days.',
        startCooking: 'Cooking {n} servings',
        fromCookingHint: 'This serving comes from cooking — change it on the day you cook.',
        day: 'Day',
        slot: 'Meal time',
        cookMode: 'Cooking mode',
        ateSomethingElse: 'I ate something else',
        backToPlan: 'Back to plan',
        eaten: 'Eaten',
        deleteTitle: 'Delete this entry?',
        deleteMessage: 'It will disappear from the day.',
    },
    mealSheet: {
        favorite: 'Favourite',
        makeFavorite: 'Add to favourites',
        loadFailed: 'Couldn’t load the meal.',
        planned: '“{name}” is in the plan.',
        planFailed: 'Couldn’t plan it.',
        duplicateFailed: 'Couldn’t duplicate it.',
        deleted: 'Meal deleted.',
        usedIn: 'First remove it from: {list}.',
        perServing: '{kcal} · {macros} — per serving',
        plan: 'Plan',
        cook: 'Cook',
        chat: 'Improve with AI',
        analysis: 'Analysis',
        duplicate: 'Duplicate',
        oneServing: 'ONE SERVING',
        moreValues: 'More values',
        servingCost: 'Cost per serving approx. {price}',
        noIngredients: 'No ingredients — add them in edit mode to count values and shopping.',
        default: 'default',
        unknownGrams: 'not sure how many grams that is — add the piece weight in edit mode',
        usedInList: 'Ingredient in: {list}',
        recipe: 'RECIPE',
        footer: 'Fits: {slots} · recipe makes {n} servings',
        eatenCount: 'eaten {n}×',
        deleteTitle: 'Delete this meal?',
        deleteMessage: 'Day entries will keep its name, while cookings and places in sets will disappear.',
    },
    cookMode: {
        label: 'Cooking mode: {name}',
        finish: 'Finish',
        timerDone: 'Done!',
        timerOff: 'Turn off timer',
        or: 'or: {list}',
        steps: 'STEPS',
        noRecipe: 'This meal doesn’t have a recipe yet — add it when editing the meal, one step per line.',
        stepDone: 'Step {n} done',
        timer: 'Timer {time}',
        allDone: 'Done — enjoy! ({n} serving) | Done — enjoy! ({n} servings)',
    },
    mealEditor: {
        defaultChoice: 'side',
        nameRequired: 'Enter a name.',
        pieceWeightRequired: 'How much does 1 pc weigh: {name}?',
        editTitle: 'Edit meal',
        emoji: 'Emoji',
        name: 'Name',
        namePlaceholder: 'e.g. Turkey with carrots',
        servingsLabel: 'The recipe makes',
        slots: 'Fits',
        ingredients: 'Ingredients',
        ingredientsHint: '— for the whole recipe',
        mealAsIngredient: 'Meal as an ingredient',
        amount: 'Amount: {name}',
        unit: 'Unit: {name}',
        makeChoice: 'Make this a choice ingredient',
        choiceIngredient: 'Choice ingredient',
        remove: 'Remove {name}',
        pieceWeighs: '1 pc weighs',
        pieceWeight: 'Piece weight: {name}',
        choiceLabel: 'choice:',
        choiceName: 'Choice name: {name}',
        addOption: '+ option',
        addingOption: 'You’re adding an option to “{name}”',
        cancelLower: 'cancel',
        optionPlaceholder: 'E.g. dumplings, rice…',
        searchPlaceholder: 'Add an ingredient — a product or a meal…',
        search: 'Search ingredients',
        kindMeal: 'meal',
        kindProduct: 'product',
        createProduct: '+ New product “{name}” — AI will estimate the values',
        recipe: 'Recipe',
        recipeHint: "— one step per line; “20 min” gives you a timer in cooking mode, and {'${'} or {'@@'} inserts an ingredient with its amount",
        insertIngredient: 'Insert an ingredient:',
        insertTimer: 'Timer:',
        recipePlaceholder: 'Dice the turkey.\nFry in olive oil for 8 min.\nAdd the carrots and simmer for 20 min.',
    },
    chat: {
        loading: 'Loading the conversation…',
        readingPhoto: 'Looking at the photo…',
        readingLink: 'Reading the recipe from the page…',
        thinking: 'Thinking…',
        sendFailed: 'Couldn’t send.',
        savingMeal: 'Saving the meal…',
        noMic: 'No access to the microphone.',
        transcribing: 'Recognising speech…',
        transcribeFailed: 'Couldn’t recognise the speech.',
        titleAbout: 'Chat: {name}',
        titleNew: 'New meal with AI',
        subtitleNew: 'AI takes your goals, preferences and products into account.',
        introNew: 'Describe what you want, pick an action below, paste a recipe or a link, or take a photo of a dish or a cookbook page. You’ll get a meal card — refine it further and save it when it fits.',
        photo: 'photo',
        perServing: 'per serving, recipe makes {n}',
        newBadge: 'new',
        hideRecipe: 'Hide recipe',
        showRecipe: 'Show recipe',
        saved: 'Saved',
        apply: 'Apply to “{name}”',
        saveAsNew: 'Save as new',
        saveAsMeal: 'Save as a meal',
        chosenPhoto: 'Chosen photo',
        removePhoto: 'Remove photo',
        addPhoto: 'Add a photo',
        stopRecording: 'Stop recording',
        record: 'Record',
        placeholderAbout: 'E.g. make a gluten-free version',
        placeholderNew: 'Describe a meal, paste a recipe or a link',
        sendHint: 'Send (Ctrl+Enter)',
        assistantHint: 'Ask for changes — you’ll see them before anything is applied.',
        introAbout: 'Say what to change or pick an action below. You’ll get a proposal with a list of changes — the meal changes only when you click “Apply changes”.',
        kept: 'The conversation stays with the meal — you can come back to it.',
        backToMeal: 'Meal',
        hideAssistant: 'Hide',
        proposal: 'PROPOSAL',
        applyChanges: 'Apply changes',
        showAll: 'Show all ingredients',
        hideAll: 'Hide ingredients',
        diff: {
            heading: 'PROPOSED CHANGES',
            headingPrevious: 'CHANGES SINCE THE PREVIOUS PROPOSAL',
            perServing: 'per serving',
            sameValues: 'Values per serving unchanged.',
            protein: 'P',
            carbs: 'C',
            fat: 'F',
            name: 'New name: {name}',
            servings: 'Servings: {from} → {to}',
            recipe: 'Recipe changed',
        },
        start: {
            quickDinner: 'Quick lunch',
            quickDinnerText: 'A quick lunch under 30 minutes, about 600 kcal',
            proteinBreakfast: 'Protein breakfast',
            proteinBreakfastText: 'A breakfast with lots of protein',
            lightSupper: 'Light dinner',
            lightSupperText: 'A light dinner under 400 kcal',
            fromMine: 'From my products',
            fromMineText: 'Suggest a meal made mostly from the products in my catalogue.',
            goals: 'For my goals',
            goalsText: 'Suggest a meal that fits my daily goals well.',
            photo: 'Photo of a dish or recipe',
            paste: 'Paste a recipe or link',
        },
        actions: {
            label: 'Quick actions',
            fewerCalories: 'Fewer calories',
            fewerCaloriesText: 'Cut the calories by about 20%, keeping the taste and fullness.',
            moreProtein: 'More protein',
            moreProteinText: 'Add more protein without adding many calories.',
            goals: 'Fit my goals',
            goalsText: 'Adjust this meal to my daily goals.',
            swap: 'Swap an ingredient',
            swapText: 'Replace ',
            servings: 'Change servings',
            servingsText: 'Scale the recipe to ',
            vegetarian: 'Vegetarian',
            vegetarianText: 'Make a vegetarian version.',
            quicker: 'Quicker',
            quickerText: 'Simplify the recipe so it’s ready faster.',
        },
        message: 'Message',
        send: 'Send',
    },
    planAi: {
        working: 'Planning…',
        nameFromNote: 'Day: {note}',
        defaultName: 'Day for my goal',
        failed: 'Couldn’t plan the day.',
        addedToPlan: 'Added to the plan: {n}.',
        state: {
            ok: 'on target',
            under: 'too little',
            over: 'too much',
        },
        dayTitle: 'Fill the day · {day}',
        daySubtitle: 'AI will fill the empty meal times with your meals, starting with servings from cooking.',
        setSubtitle: 'AI will put a day together from your meals so you hit your goals.',
        dayPlaceholder: 'Wishes (optional), e.g. a light dinner',
        setPlaceholder: 'E.g. a training day, no dairy',
        wishes: 'Wishes',
        again: 'Try again',
        propose: 'Plan',
        emptyDay: 'There’s nothing to fill here, or there are no matching meals.',
        emptySet: 'There aren’t enough meals to put a day together.',
        wholeDay: 'Whole day: {kcal} · {macros}',
        missing: 'It would help to have: {meal}',
        askRecipe: 'Ask AI for a recipe',
        setName: 'Set name',
        addToPlan: 'Add to plan ({n})',
        saveSet: 'Save set',
    },
    productSheet: {
        loadFailed: 'Couldn’t load the product.',
        priceRequired: 'Enter the price per kilogram.',
        removeVariantFailed: 'Couldn’t delete the variant.',
        usedIn: 'It’s used in meals: {list} — remove it from them first.',
        product: 'Product',
        lastBrand: 'last: {brand}',
        per100: 'PER 100 G',
        restoreValues: 'Restore automatic values',
        correct: 'Correct',
        valuesHint: 'Calories are calculated from protein, carbs and fat. Your correction wins over the label and the estimate.',
        price: 'PRICE',
        restorePrice: 'Restore automatic price',
        priceEarlier: 'entered earlier',
        priceUnknown: 'Not known yet — it will come from a receipt, Groceries shopping or an estimate.',
        perKg: 'Per kilogram ({currency})',
        inShop: 'IN THE SHOP',
        scan: 'Scan packaging',
        noVariants: 'Scan the barcode on the packaging — the brand, label values and package size will fill in by themselves.',
        labelCorrected: 'label corrected',
        label: 'label',
        noLabel: 'no label',
        removeVariant: 'Delete variant {name}',
        details: 'DETAILS',
        change: 'Change',
        noCategoryLower: 'no category',
        inMeals: 'In meals: {list}',
        name: 'Name (generic, no brand)',
        category: 'Shop category',
        noCategory: 'No category',
        pieceWeight: 'Weight of 1 piece (g)',
        pieceName: 'A piece is',
        pieceNamePlaceholder: 'e.g. egg',
        density: 'Density (g/ml)',
        delete: 'Delete product',
        deleteTitle: 'Delete this product?',
        deleteMessage: 'It will disappear from the catalogue along with its variants.',
    },
    scan: {
        unknownCode: 'I don’t know this barcode — take a photo of the nutrition label.',
        unreadable: 'Couldn’t read the label — try closer, with the nutrition table.',
        aiUnavailable: 'AI is unavailable right now — pick a product and try later.',
        title: 'Packaging',
        checking: 'Checking the packaging…',
        takePhoto: 'Take a photo of the label',
        again: 'Scan the barcode again',
    },
    quick: {
        recognising: 'Recognising…',
        notRecognised: 'I didn’t recognise any food — try e.g. “scrambled eggs from 3 eggs and a slice of bread”.',
        recogniseFailed: 'Couldn’t recognise it.',
        noSound: 'I can’t hear anything — check your microphone.',
        noSpeech: 'No speech recognised — try again.',
        dictationUnavailable: 'Dictation is unavailable right now.',
        recordingFailed: 'Couldn’t send the recording.',
        titleInstead: 'What did you eat instead?',
        title: 'What did you eat?',
        instead: 'Instead of: {name}',
        subtitle: 'Say it or type it — you’ll see a preview before saving.',
        platePhoto: 'Photo of your plate',
        addNote: 'Add anything that isn’t visible (optional)',
        orType: 'Or type it',
        placeholder: 'e.g. coffee with milk and a sweet bun',
        fromCatalogue: 'From your catalogue',
        fromCatalogueShort: 'from catalogue',
        total: 'Total {kcal}',
        editDescription: 'Edit description',
        recognise: 'Recognise',
        saveEaten: 'Save as eaten',
    },
    setEditor: {
        nameRequired: 'Enter a set name.',
        saveFailed: 'Couldn’t save the set.',
        title: 'Day set',
        newTitle: 'New day set',
        ofGoal: '{kcal} of {goal}',
        namePlaceholder: 'e.g. Training day',
        add: '+ Add',
        removeItem: 'Remove from set',
        deleteTitle: 'Delete this set?',
        deleteMessage: 'Entries inserted from it will stay.',
    },
    analysis: {
        goals: {
            health: { label: 'General health', hint: 'fibre, protein, less saturated fat' },
            active: { label: 'For active people', hint: 'protein and energy around training' },
            cut: { label: 'Weight loss', hint: 'fewer calories, just as filling' },
            lessSugarSalt: { label: 'Less sugar and salt', hint: 'without losing flavour' },
        },
        goalRequired: 'Choose a goal or describe what you want.',
        errors: {
            noIngredients: 'The meal has no ingredients to analyse.',
            aiError: 'AI service error — try again.',
            notConfigured: 'The AI service isn’t configured.',
            generic: 'Couldn’t analyse the meal.',
            conflict: 'This change can no longer be applied — the ingredient has changed in the meantime.',
            apply: 'Couldn’t apply the change.',
        },
        type: {
            changeAmount: 'Change amount',
            replace: 'Replace',
            add: 'Add',
            remove: 'Remove',
        },
        delta: {
            protein: 'P',
            carbs: 'C',
            fat: 'F',
            sugar: 'sugars',
            fiber: 'fibre',
            salt: 'salt',
        },
        before: {
            protein: 'protein',
            carbs: 'carbs',
            fat: 'fat',
        },
        badge: 'AI ANALYSIS',
        angle: 'From what angle?',
        note: 'Your own wishes',
        noteHint: '— optional, or instead of a goal',
        notePlaceholder: 'e.g. no dairy, more vegetables, ready in 15 minutes',
        backToResult: 'Back to the analysis',
        running: 'Analysing…',
        run: 'Analyse',
        beforeTitle: 'SERVING BEFORE CHANGES',
        noSuggestions: 'The AI has no suggested changes — the meal fits the goal.',
        newProduct: 'new product',
        apply: 'Apply',
        applied: 'Applied',
        estimateNote: 'Macro changes are estimates, for one serving.',
        new: 'New analysis',
    },
    picker: {
        placeholder: 'Start typing a name',
        semi: 'semi-product · {kcal} kcal / {portion}',
        free: 'Not in the catalogue — I’ll add “{name}” without macros.',
        none: 'There’s no such product in the catalogue.',
    },
    recipeEditor: {
        bold: 'Bold',
        italic: 'Italic',
        numbered: 'Numbered list — a number turns the line into a step you can tick off',
        insertRef: 'Insert a reference to the ingredient: {name}',
        placeholder: "1. Put the ${'{'}oats{'}'} in a pan…",
        hint: 'A number at the start of a line turns it into a step you can tick off. Insert an ingredient with {dollar} or {at} — both work the same.',
        save: 'Save recipe',
    },
    recipeImport: {
        errors: {
            invalid: 'Paste the recipe summary (20,000 characters at most).',
            analyze: 'Couldn’t analyse the recipe.',
        },
        mode: {
            new: 'New semi-product',
            existing: 'Existing semi-product',
            flatten: 'Don’t make a semi-product — ingredients go into the meal',
        },
        title: 'Recipe import',
        pasteSubtitle: 'Paste a ready summary: ingredients with weights and preparation steps.',
        reviewSubtitle: 'Check the matches before saving — nothing has been saved yet.',
        summary: 'Recipe summary',
        summaryPlaceholder: 'Pasta with pesto (1 serving)\n- 100 g penne pasta\n- …\n\n1. Cook the pasta…',
        mealName: 'Meal name',
        category: 'Category',
        duplicate: 'The meal “{name}” already exists — saving will create a second one. Rename it if it’s a different variant.',
        servingsSplit: 'The recipe was for {n} servings — amounts have been divided into one serving.',
        ingredientsOne: 'Ingredients (1 serving)',
        addedManually: 'added manually',
        grams: 'Grams: {name}',
        removeIngredient: 'Remove ingredient',
        or: 'or:',
        pickOr: 'Pick a product from the catalogue or',
        createNew: 'create a new “{name}”',
        addIngredient: 'Add ingredient',
        skipped: 'Skipped (no amount):',
        addWithWeight: 'Add with weight',
        semi: 'Semi-product: {name}',
        mealPortions: 'Servings in the meal',
        whichSemi: 'Which semi-product',
        pickSemi: 'Choose a semi-product',
        portions: 'Servings',
        portionName: 'Serving name',
        flattenHint: 'The ingredients will go straight into the meal, scaled to its serving ({used} of {total} semi-product servings).',
        ingredientsSemi: 'Ingredients (whole semi-product)',
        inMeal: 'in the meal: {g} g',
        semiRecipe: 'Semi-product recipe',
        newProducts: 'New products ({n})',
        newProductsHint: 'Values per 100 g were estimated by AI; salt in mg, price in {currency}/kg.',
        productName: 'Product name {name}',
        collapse: 'Collapse',
        macros: 'Macros',
        requirements: 'To save, you need a name, and every ingredient needs a product and grams (semi-product: a name or a choice from the list).',
        backToText: 'Back to the text',
        analyze: 'Analyse',
        save: 'Save meal',
    },
    firstSteps: {
        goals: {
            title: 'Nutrition goal',
            action: 'Set goals',
            what: 'Set your daily calories and, if you like, protein and the rest — or tap “Work it out for me”.',
            why: 'The day balance will show how far you are from your goal, and AI will plan days around these numbers.',
        },
        preferences: {
            title: 'Food preferences',
            action: 'Fill in',
            what: 'Allergies, what you don’t eat, what you like, your kitchen equipment and how much time you usually have for cooking.',
            why: 'Every AI suggestion in Food — meals, day sets, filling in a day — will take them into account.',
        },
        meal: {
            title: 'First meal',
            action: 'Add a meal',
            what: 'A meal is one serving of a dish with its ingredients. Describe it to AI, paste a recipe or enter the ingredients yourself.',
            why: 'You plan your days from meals — the values and cost of a serving are worked out from the ingredients.',
        },
        product: {
            title: 'Product',
            action: 'Add a product',
            what: 'A product is a general ingredient, e.g. “2% milk”. A name or a scanned package is enough.',
            why: 'Meals are calculated from products’ values per 100 g and prices. They fill in by themselves from labels, receipts and Groceries.',
        },
        plan: {
            title: 'Plan a meal',
            action: 'Plan',
            what: 'Put a meal into a meal time — for today or for the next days of the week.',
            why: 'Planned meals show in the balance as “planned”, and the week’s plan turns into a shopping list.',
        },
        eaten: {
            title: 'Eaten',
            action: 'Log what you ate',
            what: 'Tick off a planned meal, or say or type what you ate off-plan — a photo works too.',
            why: 'The day balance only counts what you’ve eaten.',
        },
        cooking: {
            title: 'Cooking several servings',
            action: 'Plan cooking',
            what: 'When planning a meal, tick “I’m cooking extra servings” and choose how many.',
            why: 'The other servings wait at the top of the picker on the following days, and only the one cooking goes to shopping.',
        },
        set: {
            title: 'Day set',
            action: 'Create a set',
            what: 'A ready layout of meals for a whole day, e.g. “Work day”. Put it together yourself or with AI.',
            why: 'You insert it into the plan in one go instead of planning the day from scratch.',
        },
    },
    help: {
        slots: {
            title: 'Meal times',
            text: 'The day’s plan laid out in meal times. Tick the circle for what you’ve eaten; “+” adds a meal to the meal time.',
            more: 'In the evening, uneaten planned meals turn grey — no penalties, no reminders. An entry opens its details: servings, swapping it for something else, cooking mode. Set meal times in Settings.',
        },
        balance: {
            title: 'Day balance',
            text: 'What you’ve eaten against your nutrition goals: calories, macros and the rest. Only what you’ve eaten counts; what’s planned is shown alongside.',
            more: 'You set goals once, in Settings → Goals and preferences — they’re shared across the whole app. Without goals the balance shows just the totals.',
        },
        quick: {
            title: 'Quick entry',
            text: 'Ate something off-plan? Say it, type it or take a photo. AI matches it to your meals and products, and you’ll see a preview before saving.',
        },
        week: {
            title: 'Week',
            text: 'The days of the week with their meal times. Empty meal times are small buttons — tap one to pick a meal. The “…” menu on a day inserts a day set or fills the day with AI.',
            more: 'The number on a day is its planned calories, with your goal after the slash — it turns red when it goes over by more than 10%. Spread cooked servings over the next days, and “To Groceries” gathers the plan\'s ingredients into a shopping list.',
        },
        basket: {
            title: 'To Groceries',
            text: 'The ingredients of planned meals go to your default list in Groceries. Before sending, untick what you already have at home.',
        },
        meals: {
            title: 'Meals',
            text: 'Your meals — each is one serving of a dish with its ingredients, calories, macros and cost per serving. The meal time filter shows what fits breakfast and what fits lunch.',
            more: 'Describe a new meal to AI (also from a link, text or photo of a recipe) or enter it yourself. From a meal’s card you can plan it, cook it in cooking mode or ask AI for an analysis.',
        },
        sets: {
            title: 'Day sets',
            text: 'Ready layouts of meals for a whole day. In Week you insert a set into a day in one go.',
            more: 'AI can put a set together from your meals so it hits your goals. Each set shows its calories against your goal.',
        },
        products: {
            title: 'Products',
            text: 'General ingredients, e.g. “2% milk”, with values per 100 g and a price. Add a new product by name alone — AI estimates the rest.',
            more: 'Values and prices fill in by themselves: from labels of scanned packages, receipts and purchases in Groceries. You mostly come here to fix a mistake. The product catalogue is shared with Groceries.',
        },
        scan: {
            title: 'Scanning a package',
            text: 'A photo of the barcode and label adds the item to a product along with the label’s values — more accurate than the AI estimate.',
        },
        slotSettings: {
            title: 'Meal times',
            text: 'Named parts of the day with an hour, e.g. Breakfast at 8:00. Every day’s plan is made of them; the hour suggests the meal time for a quick entry.',
        },
        goals: {
            title: 'Goals and preferences',
            text: 'Daily nutrition goals and preferences (allergies, what you don’t eat, equipment) are set in one place for the whole app.',
            more: 'Goals show in the day balance and in Week, and every AI suggestion in Food takes your preferences into account.',
        },
        legacy: {
            title: 'Data from the old Food',
            text: 'Moves meals, day sets and entries over from the old module. The old module stays untouched, and moving again only adds new things.',
        },
    },
    tour: {
        welcome: {
            title: 'Welcome to Food',
            description: 'Plan meals for the days of the week, tick off what you’ve eaten and see your balance against your goals. Shopping from the plan goes straight to Groceries.',
        },
        end: {
            title: 'That’s it',
            description: 'The guide is always under the “Help” button — First steps are there too. And “What’s this?” next to a section explains it without the guide.',
        },
    },
};
